import React, { lazy, useState, useEffect } from 'react'
/// React router dom
import { Switch, Route, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
/// Css
import 'leaflet/dist/leaflet.css';
import '../scss/index.scss'
import "react-toggle/style.css"
import "esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css";
import 'react-phone-input-2/lib/style.css'
import 'react-chat-elements/dist/main.css'
import "react-datepicker/dist/react-datepicker.css";

/// Layout
import Nav from './layouts/nav'
import BottomNav from './layouts/nav/BottomNav';

import { checkAutoLogin } from '../services/AuthService';

//Scroll To Top
import ScrollToTop from './layouts/ScrollToTop';
import Notification from "../firebaseNotification/Notification";
import ActiveRides from "./components/Public/Rides/ActiveRides";
import { isTerminal } from "./common/utils";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { uk } from "date-fns/locale";
import { ThemeProvider } from "@mui/material";
import { getMuiTheme } from "../theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import TerminalIdleModal from './common/TerminalIdleModal';
// /// App
const PublicHome = lazy(() => import('./components/Public/Home'));
const Restaurant = lazy(() => import('./components/Public/Restaurants/show'));
const Profile = lazy(() => import('./components/Public/Profile'));
const Checkout = lazy(() => import('./components/Public/Checkout'));
const MenuIndex = lazy(() => import('./components/Public/Menu/index'));
const Orders = lazy(() => import('./components/Public/Orders/index'));
const Order = lazy(() => import('./components/Public/Orders/show'));
const Install = lazy(() => import('./components/Public/Install'));
const ActiveOrders = lazy(() => import('./components/Public/Orders/ActiveOrders'));
const Company = lazy(() => import('./components/Public/Company'));
const RideRequest = lazy(() => import('./components/Public/Rides/RideRequest'));
const Ride = lazy(() => import('./components/Public/Rides/show'));
const PublicSales = lazy(() => import('./components/Public/Sales'));

// Carpool
const CarpoolLocationPicker = lazy(() => import('./components/Public/Carpool/CarpoolLocationPicker'));
const TripShow = lazy(() => import('./components/Public/Carpool/TripShow'));
const JourneyShow = lazy(() => import('./components/Public/Carpool/JourneyShow'));
const CarpoolWizardCalendar = lazy(() => import('./components/Public/Carpool/wizard/CarpoolWizardCalendar'));
const CarpoolWizardTime = lazy(() => import('./components/Public/Carpool/wizard/CarpoolWizardTime'));
const CarpoolWizardDetails = lazy(() => import('./components/Public/Carpool/wizard/CarpoolWizardDetails'));
const CarpoolWizardCar = lazy(() => import('./components/Public/Carpool/wizard/CarpoolWizardCar'));

// Admin
const DeliveryUsers = lazy(() => import('./components/admin/DeliveryUsers/DeliveryUsers'));
const AdminCarpools = lazy(() => import('./components/admin/Carpools/AdminCarpools'));
const AdminInvoices = lazy(() => import('./components/admin/Invoices/AdminInvoices'));
const DeliveryUsersMap = lazy(() => import('./components/admin/DeliveryUsers/Map'));
const AdminSettings = lazy(() => import('./components/admin/AdminSettings'));
const Dashboard = lazy(() => import('./components/admin/Dashboard/Dashboard'));
const DeliveryOrders = lazy(() => import('./components/admin/Deliveries/DeliveryOrders'));
const DeliveryOrder = lazy(() => import('./components/admin/Deliveries/show'));
const MyDeliveryOrders = lazy(() => import('./components/admin/Deliveries/index'));
const DeliverySettings = lazy(() => import('./components/admin/Deliveries/DeliverySettings'));
const RestaurantOrders = lazy(() => import('./components/admin/RestaurantOrders'));
const PayChecks = lazy(() => import('./components/admin/PayChecks'));
const Settings = lazy(() => import('./components/admin/Settings/Settings'));
const GeneralSettings = lazy(() => import('./components/admin/Settings/General'));
const SalesSettings = lazy(() => import('./components/admin/Settings/Sales'));
const ServicesSettings = lazy(() => import('./components/admin/Settings/Services'));
const MenuSettings = lazy(() => import('./components/admin/Settings/Menu'));
const ScheduleSettings = lazy(() => import('./components/admin/Settings/CategoriesHours'));
const TablesSettings = lazy(() => import('./components/admin/Settings/Tables'));
const StuffSettings = lazy(() => import('./components/admin/Settings/Stuff'));
const CompetitorsSettings = lazy(() => import('./components/admin/Settings/Competitors'));
const StopList = lazy(() => import('./components/admin/StopList'));
const Support = lazy(() => import('./components/admin/Support'));
const Analytics = lazy(() => import('./components/admin/Analytics'));
const RestaurantGuests = lazy(() => import('./components/admin/RestaurantGuests'));
const ManagerOrders = lazy(() => import('./components/admin/ManagerOrders'));
const Kiosk = lazy(() => import('./components/admin/Kiosk'));
const TelegramGroupDashboard = lazy(() => import('./components/admin/TelegramGroupDashboard'));
const TelegramGroupPublicProfile = lazy(() => import('./components/Public/TelegramGroupPublicProfile'));

//pages
const AuthorizeAccess = lazy(() => import('../jsx/pages/AuthorizeAccess'));
const SignUp = lazy(() => import('../jsx/pages/Registration'));
const Terms = lazy(() => import('../jsx/pages/Terms'));
const Oferta = lazy(() => import('../jsx/pages/Oferta'));
const Policy = lazy(() => import('../jsx/pages/Policy'));
const About = lazy(() => import('../jsx/pages/About'));
const ForgotPassword = lazy(() => import('../jsx/pages/ForgotPassword'));
const Password = lazy(() => import('../jsx/pages/Password'));
const Login = lazy(() => {
  return new Promise(resolve => {
    setTimeout(() => resolve(import('../jsx/pages/Login')), 100);
  });
});
const GoogleAuthCallback = lazy(() => import('../jsx/pages/GoogleAuthCallback'));
const RivneLanding = lazy(() => import('./pages/rivne/landing'));

const Markup = (props) => {
  let path = window.location.pathname;
  path = path.split('/');
  path = path[path.length - 1];
  let pagePath = path.split('-').includes('page');
  const [activeEvent, setActiveEvent] = useState(!path);
  const storeAuth = useSelector(store => store.auth);
  const theme = storeAuth.auth.userData?.theme || 'light';
  const [idleModalOpen, setIdleModalOpen] = useState(false);
  const idleTimeoutRef = React.useRef();
  const store = useSelector(store => store.restaurants);

  useEffect(() => { // for terminal
    if (!isTerminal() || (isTerminal() && store.showTerminalModal && !path.startsWith('/orders'))) return;
    const resetTimer = () => {
      clearTimeout(idleTimeoutRef.current);
      setIdleModalOpen(false);
      idleTimeoutRef.current = setTimeout(() => setIdleModalOpen(true), 60000);
    };
    window.addEventListener('mousedown', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('touchstart', resetTimer);
    resetTimer();
    return () => {
      clearTimeout(idleTimeoutRef.current);
      window.removeEventListener('mousedown', resetTimer);
      window.removeEventListener('keydown', resetTimer);
      window.removeEventListener('touchstart', resetTimer);
    };
  }, [store.showTerminalModal]);

  const handleIdleTimeout = React.useCallback(() => { // for terminal
    setIdleModalOpen(false);
    window.location.href = '/r/sofiya-aqua/menu/1205'; // change after terminal app replace
  }, []);

  const loginRoutes = [
    { url: "login", component: Login },
    { url: "auth/google/callback", component: GoogleAuthCallback },
    { url: "register", component: SignUp },
    { url: "forgot-password", component: ForgotPassword },
    { url: "password", component: Password },
    { url: "terms", component: Terms },
    { url: "privacy-policy", component: Policy },

    { url: "oferta", component: Oferta },
    { url: 'rivne', component: RivneLanding }
  ];

  const routes = [
    { url: "/", component: PublicHome },
    { url: 'restaurants/:id', component: Restaurant },
    { url: 'r/:id', component: Restaurant },
    { url: 'checkout/:id', component: Checkout },
    { url: 'check-out/:id', component: Checkout },
    { url: 'restaurants/:id/menu', component: MenuIndex },
    { url: 'restaurants/:id/:category_id/menu', component: MenuIndex },
    { url: 'restaurants/:id/:category_id/menu/:table_id', component: MenuIndex },
    { url: 'r/:id/menu', component: MenuIndex },
    { url: 'r/:id/menu/:table_id', component: MenuIndex },
    { url: 'r/:id/sale/:sale_id/menu', component: MenuIndex },
    { url: 'r/:id/sale/:sale_id/menu/:table_id', component: MenuIndex },
    { url: 'r/:id/sale/:sale_id', component: MenuIndex },
    { url: 'r/:id/:category_id/menu', component: MenuIndex },
    { url: 'r/:id/:category_id/menu/:table_id', component: MenuIndex },
    { url: 'menu/:id', component: MenuIndex },
    { url: 'install', component: Install },
    { url: 'share_order/:id', component: Order },
    { url: 'access', component: AuthorizeAccess },
    { url: 'taxi/:id', component: RideRequest },
    { url: 'taxi', component: RideRequest },
    { url: 'rides/:id', component: Ride },
    { url: 'c/:id', component: Company },
    { url: 'c/:id/:category_id', component: Company },
    { url: 'trips', component: CarpoolLocationPicker },
    { url: 'trips/new', component: CarpoolLocationPicker },
    { url: 'journeys', component: CarpoolLocationPicker },
    { url: 'journeys/new', component: CarpoolLocationPicker },
    { url: 'trips/:id/calendar', component: CarpoolWizardCalendar },
    { url: 'trips/:id/time', component: CarpoolWizardTime },
    { url: 'trips/:id/details', component: CarpoolWizardDetails },
    { url: 'trips/:id/car', component: CarpoolWizardCar },
    { url: 'journeys/:id/calendar', component: CarpoolWizardCalendar },
    { url: 'journeys/:id/time', component: CarpoolWizardTime },
    { url: 'journeys/:id/details', component: CarpoolWizardDetails },
    { url: 'trips/:id', component: TripShow },
    { url: 'journeys/:id', component: JourneyShow },
    { url: 'g/:slug', component: TelegramGroupPublicProfile },
    { url: 'sales', component: PublicSales },
    { url: "about", component: About },
  ];

  const authRoutes = [
    { url: 'profile', component: Profile },
    { url: 'orders', component: Orders },
    { url: 'orders/:id', component: Order },
  ];

  const adminRoutes = [
    { url: 'delivery_users', component: DeliveryUsers },
    { url: 'delivery_users/map', component: DeliveryUsersMap },
    { url: 'delivery_settings', component: DeliverySettings },
    { url: 'admin-settings', component: AdminSettings },
    // One non-exact /dashboard route so Dashboard stays mounted across tab/table/order URLs
    // (exact child routes remounted it and re-fired getAdminOrdersAction every click)
    { url: 'dashboard', component: () => <Redirect to="/dashboard/orders" /> },
    { url: 'dashboard', component: Dashboard, exact: false },
    { url: 'admin-carpools', component: AdminCarpools },
    { url: 'admin-invoices', component: AdminInvoices },
    { url: 'admin/telegram-groups', component: TelegramGroupDashboard },
    { url: 'admin/telegram-groups/:id', component: TelegramGroupDashboard },
    { url: 'support', component: Support },
    { url: 'deliveries', component: DeliveryOrders },
    { url: 'deliveries/:id', component: DeliveryOrder },
    { url: 'driver_ride/:id', component: DeliveryOrder },
    { url: 'my-deliveries', component: MyDeliveryOrders },
    { url: 'restaurant-orders', component: RestaurantOrders },
    { url: 'paychecks', component: PayChecks },
    { url: 'settings', component: Settings },
    { url: 'settings/general', component: GeneralSettings },
    { url: 'settings/competitors', component: CompetitorsSettings },
    { url: 'settings/sales', component: SalesSettings },
    { url: 'settings/services', component: ServicesSettings },
    { url: 'settings/menu', component: MenuSettings },
    { url: 'settings/schedule', component: ScheduleSettings },
    { url: 'settings/tables', component: TablesSettings },
    { url: 'settings/stuff', component: StuffSettings },
    { url: 'stop_list', component: StopList },
    { url: 'analytics', component: Analytics },
    { url: 'restaurant_guests', component: RestaurantGuests },
    { url: 'manager_orders', component: ManagerOrders },
    { url: 'kiosk', component: Kiosk },
  ];

  const pathname = window.location.pathname;
  const isLoginRoute = loginRoutes.some(r => pathname === `/${r.url}`);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={uk}>
      <ThemeProvider theme={getMuiTheme(theme)}>
        {isLoginRoute ?
          <Switch>
            {loginRoutes.map((data, i) => (
              <Route key={i} exact path={`/${data.url}`} component={data.component} />))}
          </Switch>
          :
          <>
            <div style={{ marginBottom: 50 }} id={`${!pagePath ? 'main-wrapper' : ''}`}
              className={`${!pagePath ? 'show' : 'mh100vh'}`}
            >
              {!pagePath && (
                <Nav
                  onClick={() => setActiveEvent(!activeEvent)}
                  activeEvent={activeEvent}
                  onClick2={() => setActiveEvent(false)}
                  onClick3={() => setActiveEvent(true)}
                />)}
              <div className={` ${!path && activeEvent ? 'rightside-event' : ''} ${!pagePath ? 'content-body' : ''}`}>
                <div className={`${!pagePath ? 'container-fluid' : ''}`} style={{ minHeight: window.screen.height - 506 }}>
                  <Switch>
                    {/*<Route exact path={`/c/novograd_delivery`}*/}
                    {/*       render={(props) =>*/}
                    {/*          <PublicHome*/}
                    {/*            {...props}*/}
                    {/*            location={{landing_location: [50.597557, 27.599731]}}*/}
                    {/*          />*/}
                    {/*       }*/}
                    {/*/>*/}
                    {routes.map((data, i) => (
                      <Route key={i} exact path={`/${data.url}`} component={data.component} />
                    ))}
                    {props.isAuthenticated && (
                      <>
                        {adminRoutes.map((data, i) => (
                          <Route
                            key={`admin-${i}`}
                            exact={data.exact !== false}
                            path={`/${data.url}`}
                            component={data.component}
                          />
                        ))}
                        {authRoutes.map((data, i) => (
                          <Route key={`auth-${i}`} exact path={`/${data.url}`} component={data.component} />
                        ))}
                      </>
                    )}
                  </Switch>
                </div>
              </div>
              {/*{!pagePath && <Footer />}*/}
            </div>
            <ScrollToTop />
            {!isTerminal() && <BottomNav />}
          </>}
        {!isTerminal() && <><ActiveOrders /><ActiveRides /></>}
        {storeAuth.auth.userData?.working && <Notification />}
        <TerminalIdleModal open={idleModalOpen} onDismiss={() => setIdleModalOpen(false)} onTimeout={handleIdleTimeout} />
      </ThemeProvider>
    </LocalizationProvider>
  )
};

export default Markup
